var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gst-event-sidebar__footer"},[_c('EventTotalsContainer',{attrs:{"title":_vm.title,"event":_vm.event,"bundle-products":_vm.bundleProducts}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }